import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import CancelButton from '../inputs/CancelButton';
import InfoRow from '../inputs/InfoRow';
import { setDashboardSection, setIsAddSeatsPopupOpened, setIsUpdateSeatsPopupOpened } from '../../../redux/features/general/navigation';
import Button from '../inputs/Button';

interface Props { 

}; 

const AddSeatsPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleQuit = async () => { 

        dispatch(setIsAddSeatsPopupOpened(false)); 

    }; 

    // -- 

    const handleSeatsUpdate = async () => { 

        dispatch(setDashboardSection('billing')); 
        dispatch(setIsUpdateSeatsPopupOpened(true)); 

        navigate('/group'); 

        dispatch(setIsAddSeatsPopupOpened(false)); 

    }; 

    // -- 

    return (

        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    maxWidth: isMobile ? '90vw' : '450px',
                    width: '100%',
                    padding: isMobile ? 2 : 3,
                    borderRadius: 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    component="img"
                    sx={{
                        width: 100,
                        marginTop: 3, 
                        marginBottom: 2, 
                    }}
                    src={require('../../../assets/icons/paywall/medical-report.png')}
                />

                <Box
                    sx={{ 
                        width: '90%',
                        flexDirection: 'column', 
                        alignItems:'center',
                        justifyContent: 'space-evenly',
                        fontSize: 18, 
                        color: colors?.text,
                        fontWeight: 'bold', 
                        marginTop: 1,
                        marginBottom: 1, 
                    }}
                >{t('addSeats')}
                </Box>

                <Box
                    sx={{ 
                        width: '90%',
                        flexDirection: 'column', 
                        alignItems:'center',
                        justifyContent: 'space-evenly',
                        fontSize: 12, 
                        color: 'rgb(150, 150, 150)',
                        marginTop: 1,
                        marginBottom: 1, 
                    }}
                >{t('addSeatsPopup')}
                </Box>

                <Button 
                    title='continue'
                    triggerFunction={handleSeatsUpdate}
                    extraStyle={{ marginTop: 2, marginBottom: 2 }}
                />

                <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

            </Box>

        </Box>

  );

};

export default AddSeatsPopup;